import {Component, OnInit, Inject} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import { DateAdapter } from '@angular/material/core';
import { ErrorStateMatcher } from '@angular/material/core';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-member-payment-dialog',
  templateUrl: './member-payment-dialog.component.html',
  styleUrls: [ './member-payment-dialog.component.scss' ],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class MemberPaymentDialogComponent implements OnInit {

  public local_title: string;
  public matcher = new FormErrorStateMatcher();
  public entityForm: FormGroup;   // store User Form
  public isEdit: boolean; // is insert or update


  public origins: any[] = []
  public origin: any = "";

  public paymentTypes: any[] = [];

  public selectedPaymentType: string = "";
  public currentTax: number = 0;
  public debit_ok: boolean = false;

  public tax_visible: boolean = false;
  public value_visible: boolean = false;
  public total_visible: boolean = false;
  public total_mt_visible: boolean = false;
  public tid_visible: boolean = false;
  public discount_visible: boolean = false;

  constructor (
    private fb: FormBuilder,
    private _adapter: DateAdapter<any>,
    public matDialogRef: MatDialogRef<MemberPaymentDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    // console.log(JSON.stringify(this.data))
    this.entityForm = this.createForm()
  }

  ngOnInit () {
    this._adapter.setLocale('pt');

    this.isEdit = true;

    this.origins.push({name: "GN1", value: "GN1"})
    this.origins.push({name: "Admin", value: "Admin"})

  }

  createForm () {

    let form: FormGroup = this.fb.group({
      date: new FormControl('', [ Validators.required ]),

      payment_type: new FormControl('', [ Validators.required ]),

      value: new FormControl('', [ Validators.required ]),
      total: new FormControl('', [ Validators.required ]),
      discount: new FormControl(''),
      tax: new FormControl(''),
      total_minus_tax: new FormControl(''),

      origin: new FormControl(''),

      Tid: new FormControl(''),
      card_brand: new FormControl(''),

      product_id: new FormControl(''),
      product_name: new FormControl(''),

      category_id: new FormControl(''),
      category_name: new FormControl(''),


    });
    return form
  }

  load_payment_type (origin, type) {

    this.paymentTypes = [];

    switch (origin) {

      case "GN1":
        this.paymentTypes.push({'name': 'Boleto', 'value': 'Billet'})
        this.paymentTypes.push({'name': 'Cartão', 'value': 'CreditCard'})
        break;

      case "Admin":
        this.paymentTypes.push({'name': 'Free', 'value': 'Free'})
        this.paymentTypes.push({'name': 'Cash', 'value': 'Cash'})
        break;

    }

  }

  selectType (type) {

    this.selectedPaymentType = type
    
    this.entityForm.controls.product_id.setValue(this.data.id);
    this.entityForm.controls.product_name.setValue(this.data.name);
    this.entityForm.controls.category_id.setValue(this.data.price.category.id);
    this.entityForm.controls.category_name.setValue(this.data.price.category.name);

    this.entityForm.controls.Tid.setValue("");
    this.entityForm.controls.value.setValue(this.data.price.value);
    this.entityForm.controls.total.setValue(this.data.price.value);
    this.entityForm.controls.discount.setValue("");
    this.entityForm.controls.total_minus_tax.setValue("");

    switch (type) {
      case "Billet":
        this.currentTax = 0.035
        this.entityForm.controls.tax.setValue(this.currentTax);
        this.entityForm.controls.tax.setValue(this.currentTax);
        this.entityForm.controls.tax.setValue(this.currentTax);

        this.tax_visible = true;
        this.value_visible = true;
        this.total_visible = true;
        this.total_mt_visible = true;
        this.tid_visible = true;
        this.discount_visible = false;

        break;

      case "cartao":
      case "CreditCard":
        this.currentTax = 0.037;
        this.entityForm.controls.tax.setValue(this.currentTax);
        this.entityForm.controls.card_brand.setValue("Visa");

        this.tax_visible = true;
        this.value_visible = true;
        this.total_visible = true;
        this.total_mt_visible = true;
        this.tid_visible = true;
        this.discount_visible = false;

        break;

      case "Free":
        this.currentTax = 0;
        this.entityForm.controls.value.setValue(0);
        this.entityForm.controls.total.setValue(0);
        this.entityForm.controls.total_minus_tax.setValue(0);
        this.entityForm.controls.tax.setValue(0);
        this.entityForm.controls.discount.setValue(0);

        this.tax_visible = false;
        this.value_visible = true;
        this.total_visible = true;
        this.total_mt_visible = false;
        this.tid_visible = false;
        this.discount_visible = false;
        break;
      case "Cash":
        this.currentTax = 0;
        this.tax_visible = false;
        this.value_visible = true;
        this.total_visible = true;
        this.total_mt_visible = true;
        this.tid_visible = false;
        this.discount_visible = true;
        break;
    }

    this.value_blur()

  }

  value_blur () {

    let value = Number(this.entityForm.controls.value.value)
    let tax = Number(this.entityForm.controls.tax.value)
    let discount = Number(this.entityForm.controls.discount.value)
    let debit: number = 0;

    if (this.debit_ok) {
      debit = Number(this.entityForm.controls.member_debit.value)
    } else {
      debit = 0
    }

    //  console.log("debit " + debit)

    let total = (value - discount) + debit;
    let tax_value = Number(total * tax)
    let total_minus_tax = Number(total - tax_value)

    if (value > 0)
      this.entityForm.controls.value.setValue(value);

    if (total > 0)
      this.entityForm.controls.total.setValue(total);

    if (total_minus_tax)
      this.entityForm.controls.total_minus_tax.setValue(total_minus_tax);

  }

  include_debit (event) {

    if (event.checked) {
      this.debit_ok = true;
    } else {
      this.debit_ok = false;
    }


    this.value_blur()
  }

  reset_visible () {
    this.tax_visible = false;
    this.value_visible = false;
    this.total_visible = false;
    this.total_mt_visible = false;
    this.tid_visible = false;
    this.discount_visible = false;
  }

  selectOrigin (origin) {
    this.origin = origin
    this.load_payment_type(origin, null)
    this.reset_visible()
  }

}
